import { KeyboardEvent, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";

import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { usePRD1010_R01Store } from "./Store_PRD1010_R01";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const PRD1010_R01SearchSection = ({ onEnterKeyDown }: Props) => {

	const { PRD1010_R01Filter, setPRD1010_R01Filter } = usePRD1010_R01Store();
	const { compCdList, yesNoList } = useCommonCodeStore();
	
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
    <SearchSectionForm>
		{/* PRD1010_R01Filter : {JSON.stringify(PRD1010_R01Filter)} */}
		<SearchDropDownForm
			label="사업장"
			value={PRD1010_R01Filter.compCd}
			optionList={compCdList}
			onChangeItem={(selectedItem) => setPRD1010_R01Filter({ compCd: selectedItem?.compCd || '' })}
		/>
		
		<SearchMonthSingleForm
				label="생산년월"
				visible={pickerVisible}		setVisible={setPickerVisible}
				value={new Date(PRD1010_R01Filter.yearMonth)}
				editable={true}
				onChange={(date) => setPRD1010_R01Filter({ yearMonth: formatDateYear4(date)+'-'+formatDateMonth(date) })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

		{/* PRD1010_R01Filter : {JSON.stringify(PRD1010_R01Filter)} <br/> */}
	</SearchSectionForm>
  );
};